(function () {
  document.documentElement.dataset.bcfMessage = 'minimal';
  var root = document.querySelector('[data-bcf-pdp]');
  var info = root && root.querySelector('.pdp-info');
  if (!root || !info) return;

  var config = window.BCFMinimalConfig || {};
  var assetBase = config.assetBase || '';
  function asset(name) { return assetBase + String(name || '').replace(/\?.*$/, ''); }
  var sku = (root.dataset.bcfSku || '040').toUpperCase();
  var messages = {
    '040': 'The quiet everyday Rope: visible at 2.0mm without taking over.',
    '050': 'The balanced everyday Rope: enough presence without becoming a statement.',
    '060': 'A more noticeable Rope for when you want the chain to register.',
    '070': 'The fullest Rope in the launch assortment, built for obvious presence.'
  };
  var title = info.querySelector('h1');
  var productName = title ? title.textContent.trim() : 'Rope';
  if (title) title.insertAdjacentHTML('afterend', '<p class="minimal-pdp-line">' + (messages[sku] || messages['040']) + '</p>');

  var priceNote = info.querySelector('.price-row .note');
  var currentWeight = document.getElementById('p-weight');
  if (priceNote && currentWeight) priceNote.innerHTML = '<b id="p-weight">' + currentWeight.textContent + '</b> · solid 925 sterling';

  var form = document.getElementById('bcf-buy-form');
  var cartPrice = document.getElementById('p-cart');
  var atc = form && form.querySelector('[data-atc]');
  function selectedLengthText() {
    var selected = document.querySelector('.lens .len.on .in');
    return selected ? selected.textContent : '20″';
  }
  function refreshAtcLabel() {
    var price = document.getElementById('p-cart');
    if (atc && price) atc.innerHTML = 'Add ' + productName + ' to bag · <span id="p-cart">' + price.textContent + '</span>';
  }
  refreshAtcLabel();
  if (form) form.insertAdjacentHTML('afterend', '<p class="minimal-reassurance">Free insured U.S. shipping <span>·</span> 30-day returns</p><p class="minimal-add-status" role="status" aria-live="polite"></p>');
  if (atc) atc.addEventListener('click', function () {
    var status = document.querySelector('.minimal-add-status');
    if (status) status.textContent = 'Opening your bag…';
  });

  var fitLink = root.querySelector('[data-open-fit-gallery]');
  if (fitLink) fitLink.textContent = 'Compare all four lengths';

  var gallery = root.querySelector('.gal');
  var thumbs = gallery && gallery.querySelector('.thumbs');
  var stage = gallery && gallery.querySelector('.main');
  var mainImage = document.getElementById('pdp-main-img');
  if (thumbs && stage && mainImage) {
    var modelThumb = thumbs.querySelector('[data-gallery-kind="model"]');
    var wholeThumb = thumbs.querySelector('[data-gallery-kind="whole"]');
    var detailThumb = thumbs.querySelector('[data-gallery-kind="detail"]');
    var materialThumb = thumbs.querySelector('[data-gallery-kind="clasp"]');
    var fitThumb = thumbs.querySelector('[data-gallery-kind="fit"]');
    var galleryAssets = {
      '040': {
        presence: asset('bcf-proof-width-v11.jpg'),
        presenceThumb: asset('bcf-proof-presence-040-thumb-160.jpg'),
        presenceAlt: 'Negative-space proof frame explaining the exact 2.0mm presence of Rope 040',
        presenceLabel: 'View 2mm presence proof',
        lengths: asset('bcf-proof-lengths-v3.jpg'),
        lengthsThumb: asset('bcf-proof-lengths-040-thumb-160.jpg'),
        lengthsAlt: 'Four Rope 040 length positions labeled 18, 20, 22, and 24 inches',
        everyday: asset('bcf-proof-everyday-v11.jpg'),
        everydayThumb: asset('bcf-proof-everyday-thumb-160.jpg'),
        everydayAlt: 'Negative-space lifestyle frame showing the Subtle Rope finishing an everyday outfit',
        everydayLabel: 'View Subtle Rope everyday styling proof'
      },
      '050': {
        presence: asset('bcf-proof-presence-050-v1.jpg'),
        presenceThumb: asset('bcf-proof-presence-050-thumb-160.jpg'),
        presenceAlt: 'Negative-space proof frame showing the Balanced Rope at 2.5mm and 20 inches',
        presenceLabel: 'View Balanced Rope presence proof',
        lengths: asset('bcf-proof-lengths-050-v1.jpg'),
        lengthsThumb: asset('bcf-proof-lengths-050-thumb-160.jpg'),
        lengthsAlt: 'Balanced Rope shown at 18, 20, 22, and 24 inches on the same model',
        everyday: asset('bcf-proof-everyday-050-v2.jpg'),
        everydayThumb: asset('bcf-proof-everyday-050-v2-thumb-160.jpg'),
        everydayAlt: 'Negative-space lifestyle frame showing the Balanced Rope as visible without feeling heavy',
        everydayLabel: 'View Balanced Rope everyday styling proof'
      },
      '060': {
        presence: asset('bcf-proof-presence-060-v1.jpg'),
        presenceThumb: asset('bcf-proof-presence-060-thumb-160.jpg'),
        presenceAlt: 'Negative-space proof frame showing the Present Rope at 2.8mm and 20 inches',
        presenceLabel: 'View Present Rope presence proof',
        lengths: asset('bcf-proof-lengths-060-v1.jpg'),
        lengthsThumb: asset('bcf-proof-lengths-060-thumb-160.jpg'),
        lengthsAlt: 'Present Rope shown at 18, 20, 22, and 24 inches on the same model',
        everyday: asset('bcf-proof-everyday-060-v2.jpg'),
        everydayThumb: asset('bcf-proof-everyday-060-v2-thumb-160.jpg'),
        everydayAlt: 'Negative-space lifestyle frame showing the Present Rope with clear definition on its own',
        everydayLabel: 'View Present Rope everyday styling proof'
      },
      '070': {
        presence: asset('bcf-proof-presence-070-v1.jpg'),
        presenceThumb: asset('bcf-proof-presence-070-thumb-160.jpg'),
        presenceAlt: 'Negative-space proof frame showing the Statement Rope at 3.2mm and 20 inches',
        presenceLabel: 'View Statement Rope presence proof',
        lengths: asset('bcf-proof-lengths-070-v1.jpg'),
        lengthsThumb: asset('bcf-proof-lengths-070-thumb-160.jpg'),
        lengthsAlt: 'Statement Rope shown at 18, 20, 22, and 24 inches on the same model',
        everyday: asset('bcf-proof-everyday-070-v2.jpg'),
        everydayThumb: asset('bcf-proof-everyday-070-v2-thumb-160.jpg'),
        everydayAlt: 'Negative-space lifestyle frame showing the Statement Rope as a clean solo chain',
        everydayLabel: 'View Statement Rope everyday styling proof'
      }
    };
    var selectedAssets = galleryAssets[sku] || galleryAssets['040'];

    var widthComparisonImage = asset('bcf-proof-widths-four-final-v1.jpg');
    var widthComparisonThumb = asset('bcf-proof-widths-four-final-v1-thumb-160.jpg');

    function makeProofThumb(kind, image, thumbnail, alt, label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.dataset.galleryKind = kind;
      button.dataset.full = image;
      button.dataset.alt = alt;
      button.setAttribute('aria-label', label);
      button.innerHTML = '<img src="' + thumbnail + '" alt="" width="70" height="70" loading="lazy" decoding="async">';
      return button;
    }

    var presenceThumb = makeProofThumb('proof-presence', selectedAssets.presence, selectedAssets.presenceThumb, selectedAssets.presenceAlt, selectedAssets.presenceLabel);
    var widthsThumb = makeProofThumb(
      'proof-widths',
      widthComparisonImage,
      widthComparisonThumb,
      'AI-assisted visual comparison of four diamond-cut Rope widths ordered 2.0, 2.5, 2.8, and 3.2 millimeters',
      'Compare all four Rope widths'
    );
    widthsThumb.insertAdjacentHTML('beforeend', '<span class="minimal-width-thumb-label" aria-hidden="true">4 widths</span>');
    var everydayThumb = selectedAssets.everyday ? makeProofThumb('proof-everyday', selectedAssets.everyday, selectedAssets.everydayThumb, selectedAssets.everydayAlt, selectedAssets.everydayLabel) : null;
    if (detailThumb) {
      detailThumb.dataset.galleryKind = 'proof-macro';
      detailThumb.dataset.full = asset('bcf-rope-' + sku + '-macro-enhanced-v1.jpg');
      detailThumb.dataset.alt = 'Enhanced macro view of the ' + productName + ' link construction; not actual size';
      detailThumb.setAttribute('aria-label', 'View an enhanced macro of the Rope ' + sku + ' pattern');
      detailThumb.querySelector('img').src = asset('bcf-rope-' + sku + '-macro-enhanced-thumb-160.jpg');
      detailThumb.querySelector('img').loading = 'lazy';
      detailThumb.querySelector('img').decoding = 'async';
    }

    if (materialThumb) {
      materialThumb.dataset.galleryKind = 'proof-material';
      materialThumb.dataset.full = asset('bcf-proof-material-v12.jpg');
      materialThumb.dataset.alt = 'Negative-space proof frame using the actual BCF clasp and struck 925 sterling hallmark';
      materialThumb.setAttribute('aria-label', 'View actual 925 hallmark proof');
      materialThumb.querySelector('img').src = asset('bcf-proof-material-thumb-160.jpg');
      materialThumb.querySelector('img').loading = 'lazy';
      materialThumb.querySelector('img').decoding = 'async';
    }
    if (fitThumb) {
      fitThumb.dataset.galleryKind = 'proof-lengths';
      fitThumb.dataset.full = selectedAssets.lengths;
      fitThumb.dataset.alt = selectedAssets.lengthsAlt;
      fitThumb.setAttribute('aria-label', 'View the four-length decision guide');
      fitThumb.querySelector('img').src = selectedAssets.lengthsThumb;
      fitThumb.querySelector('img').loading = 'lazy';
      fitThumb.querySelector('img').decoding = 'async';
      var fitBadge = fitThumb.querySelector('.thumb-fit-label');
      if (fitBadge) fitBadge.remove();
    }
    [modelThumb, detailThumb, widthsThumb, fitThumb, presenceThumb, materialThumb, everydayThumb, wholeThumb].forEach(function (button) {
      if (button) thumbs.appendChild(button);
    });

    var widthProof = document.createElement('div');
    widthProof.className = 'minimal-width-proof';
    widthProof.setAttribute('aria-hidden', 'true');
    widthProof.innerHTML = '<header class="minimal-width-proof__head"><span>Which width is yours?</span><strong>See the difference.</strong></header>' +
      '<div class="minimal-width-proof__labels">' +
        '<span><b>2.0</b><small>mm</small></span>' +
        '<span><b>2.5</b><small>mm</small></span>' +
        '<span><b>2.8</b><small>mm</small></span>' +
        '<span><b>3.2</b><small>mm</small></span>' +
      '</div>' +
      '<svg class="minimal-width-proof__leaders" viewBox="0 0 1200 1200" preserveAspectRatio="none" focusable="false" aria-hidden="true"><path d="M486 160L461 360M594 160L534 310M702 160L606 260M810 160L680 220"/></svg>';
    stage.appendChild(widthProof);

    function resetProofStage() {
      stage.classList.remove('is-proof-static', 'is-proof-presence', 'is-proof-material', 'is-proof-lengths', 'is-proof-everyday', 'is-proof-macro', 'is-proof-widths');
    }
    function showProofAsset(button) {
      if (!button || !/^proof-/.test(button.dataset.galleryKind || '')) return;
      thumbs.querySelectorAll('button').forEach(function (item) { item.classList.remove('on'); });
      button.classList.add('on');
      stage.classList.remove('is-link-detail', 'is-fit-guide', 'is-whole-chain');
      resetProofStage();
      stage.classList.add('is-proof-static', 'is-' + button.dataset.galleryKind);
      if (window.BCFGallerySwap) window.BCFGallerySwap(mainImage, button);
      else {
        mainImage.src = button.dataset.full;
        mainImage.alt = button.dataset.alt;
      }
      var header = document.querySelector('.bcf-header-section .hd');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      var stageTop = stage.getBoundingClientRect().top;
      if (stageTop < headerBottom + 8) window.scrollBy({ top: stageTop - headerBottom - 8, behavior: 'auto' });
    }
    thumbs.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button || !thumbs.contains(button)) return;
      if (/^proof-/.test(button.dataset.galleryKind || '')) showProofAsset(button);
      else resetProofStage();
    });
    thumbs.addEventListener('pointerdown', function (event) {
      var button = event.target.closest('button[data-full]');
      if (button && window.BCFGalleryPreload) window.BCFGalleryPreload(button.dataset.full);
    }, { passive: true });
    root.addEventListener('bcf:variant-change', resetProofStage);
  }

  var fitDialog;
  if (fitLink) {
    fitDialog = document.createElement('div');
    fitDialog.className = 'minimal-fit-dialog';
    fitDialog.id = 'minimal-fit-dialog';
    fitDialog.hidden = true;
    fitDialog.setAttribute('role', 'dialog');
    fitDialog.setAttribute('aria-modal', 'true');
    fitDialog.setAttribute('aria-labelledby', 'minimal-fit-title');
    var selectedGalleryAssets = {
      '040': asset('bcf-proof-lengths-v3.jpg'),
      '050': asset('bcf-proof-lengths-050-v1.jpg'),
      '060': asset('bcf-proof-lengths-060-v1.jpg'),
      '070': asset('bcf-proof-lengths-070-v1.jpg')
    };
    fitDialog.innerHTML = '<button type="button" class="minimal-fit-dialog__backdrop" data-fit-close tabindex="-1" aria-label="Close length guide"></button><section class="minimal-fit-dialog__sheet"><header><div><span class="eyebrow">Fit guide</span><h2 id="minimal-fit-title">Choose where it lands.</h2></div><button type="button" class="minimal-fit-dialog__close" data-fit-close aria-label="Close length guide">×</button></header><img data-src="' + selectedGalleryAssets[sku] + '" alt="' + productName + ' shown at 18, 20, 22, and 24 inches" width="1200" height="1200"><div class="minimal-fit-dialog__lengths" aria-label="Choose a length"><button type="button" data-fit-length="18">18″</button><button type="button" data-fit-length="20">20″</button><button type="button" data-fit-length="22">22″</button><button type="button" data-fit-length="24">24″</button></div><p>Neck size, build and clothing can shift the resting point slightly.</p></section>';
    document.body.appendChild(fitDialog);
    fitLink.setAttribute('aria-haspopup', 'dialog');
    fitLink.setAttribute('aria-controls', fitDialog.id);
    var lastFocus;
    function closeFitDialog() {
      fitDialog.hidden = true;
      document.documentElement.classList.remove('minimal-fit-open');
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }
    function openFitDialog() {
      lastFocus = document.activeElement;
      var fitImage = fitDialog.querySelector('img[data-src]');
      if (fitImage && !fitImage.getAttribute('src')) fitImage.src = fitImage.dataset.src;
      fitDialog.hidden = false;
      document.documentElement.classList.add('minimal-fit-open');
      fitDialog.querySelector('.minimal-fit-dialog__close').focus({ preventScroll: true });
    }
    fitLink.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openFitDialog();
    }, true);
    fitDialog.querySelectorAll('[data-fit-close]').forEach(function (button) { button.addEventListener('click', closeFitDialog); });
    fitDialog.querySelectorAll('[data-fit-length]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = Array.from(document.querySelectorAll('.lens .len')).find(function (item) {
          return item.querySelector('.in') && item.querySelector('.in').textContent.replace(/[^0-9]/g, '') === button.dataset.fitLength;
        });
        if (target) target.click();
        closeFitDialog();
      });
    });
    document.addEventListener('keydown', function (event) { if (!fitDialog.hidden && event.key === 'Escape') closeFitDialog(); });
  }

  var urgency = document.querySelector('.dispatch-urgency');
  function dispatchState(now) {
    var cutoffHour = urgency ? Number(urgency.dataset.cutoffHour || 15) : 15;
    var zone = urgency ? urgency.dataset.timeZone || 'America/Chicago' : 'America/Chicago';
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: zone, weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(now || new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    var weekday = values.weekday;
    var minutesNow = Number(values.hour) * 60 + Number(values.minute);
    var minutesLeft = cutoffHour * 60 - minutesNow;
    var businessDay = weekday !== 'Sat' && weekday !== 'Sun';
    if (businessDay && minutesLeft > 0) {
      if (minutesLeft > 180) {
        var cutoffLabel = (cutoffHour % 12 || 12) + ':00 ' + (cutoffHour >= 12 ? 'PM' : 'AM') + ' CT';
        return 'Order by ' + cutoffLabel + ' for dispatch today + FREE SHIPPING.';
      }
      var hours = Math.floor(minutesLeft / 60);
      var minutes = minutesLeft % 60;
      return 'Order within ' + (hours ? hours + 'h ' : '') + minutes + 'm for dispatch today + FREE SHIPPING.';
    }
    return 'Order now for dispatch next Houston business day + FREE SHIPPING.';
  }
  function refreshUrgency() {
    if (!urgency) return;
    var strong = urgency.querySelector('strong');
    var small = urgency.querySelector('small');
    if (strong) strong.textContent = dispatchState(new Date());
    if (small) small.textContent = 'In-stock orders. Cutoff shown in Houston time.';
  }
  refreshUrgency();
  window.setInterval(refreshUrgency, 60000);

  var sticky = document.createElement('div');
  sticky.className = 'minimal-sticky-add';
  sticky.hidden = true;
  sticky.innerHTML = '<div><strong>' + productName + '</strong><span data-sticky-selection></span></div><button type="button" data-sticky-atc></button>';
  document.body.appendChild(sticky);
  var stickySelection = sticky.querySelector('[data-sticky-selection]');
  var stickyButton = sticky.querySelector('[data-sticky-atc]');
  var hasReachedForm = false;
  function refreshStickyContent() {
    var currentPrice = document.getElementById('p-cart');
    if (stickySelection) stickySelection.textContent = selectedLengthText() + ' selected';
    if (stickyButton) stickyButton.textContent = 'Add · ' + (currentPrice ? currentPrice.textContent : '');
  }
  function refreshStickyVisibility() {
    if (!form || !window.matchMedia('(max-width: 900px)').matches) { sticky.hidden = true; return; }
    var rect = form.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) hasReachedForm = true;
    sticky.hidden = !(hasReachedForm && rect.bottom < 0 && (!fitDialog || fitDialog.hidden));
  }
  if (stickyButton && atc) stickyButton.addEventListener('click', function () { atc.click(); });
  window.addEventListener('scroll', refreshStickyVisibility, { passive: true });
  window.addEventListener('resize', refreshStickyVisibility);
  root.addEventListener('bcf:variant-change', function () {
    window.setTimeout(function () { refreshAtcLabel(); refreshStickyContent(); }, 0);
  });
  refreshStickyContent();
  refreshStickyVisibility();
  window.BCFMinimalPreview = { dispatchState: dispatchState, refreshStickyVisibility: refreshStickyVisibility };

  var specifications = document.querySelector('.specdetails');
  function keepSpecificationsOpen() { if (specifications) specifications.setAttribute('open', ''); }
  keepSpecificationsOpen();
  document.addEventListener('DOMContentLoaded', keepSpecificationsOpen, { once: true });
  document.querySelectorAll('.product-faq details').forEach(function (details) { details.removeAttribute('open'); });
  var faqTitle = document.getElementById('product-faq-title');
  if (faqTitle) faqTitle.textContent = 'Need one more answer?';
  var reviewTitle = document.querySelector('.reviews-head h2');
  if (reviewTitle) reviewTitle.textContent = 'What buyers noticed after ordering.';

})();
